<template>

    <div class="container_logo">
        <v-img :src="logo" class="logo" :transition="false">
        </v-img>
    </div>

</template>

<script>

    import logo from "../assets/logo-white.png"
    import {getCustomerLogoUrl} from "../helpers/location"

    export default {
        name: 'EcoLogo',
        data() {
            return {
                logo
            }
        },
        created(){
            const serverLogo = getCustomerLogoUrl()
            if (serverLogo){
                this.logo =  getCustomerLogoUrl()
            }
        },
    }
</script>


<style scoped lang="scss">

    .container_logo {
        padding: 15px;

        .logo {
            margin: 0 auto;
        }
    }

</style>
